module.exports = __webpack_public_path__ + "img/LOGO_FIRE KONG_2.jpg";